export const title = 'Campaign revenue';
import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.en.mdx';

Total revenue generated by sales attributed to campaigns in the selected period.

<CampaignAttributionDateNote />
